enum POSTableTabs {
  CLOUD_SERVICES = 'cloud-services',
  SWITCH_CONNECTIVITY = 'switch-connectivity',
  NETWORK_CIRCUIT = 'network-circuit',
  REGISTERS = 'registers',
}

export default POSTableTabs;
